import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-047f8cfe")

_pushScopeId("data-v-047f8cfe")
const _hoisted_1 = { class: "reportMember" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "实验报告", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "—", -1)
const _hoisted_5 = { class: "experimentScore" }
const _hoisted_6 = { class: "ranking" }
const _hoisted_7 = { class: "action flex align-items-center" }
const _hoisted_8 = { class: "page mr24" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_pagination = _resolveComponent("a-pagination")
  const _component_ManagementFrame = _resolveComponent("ManagementFrame")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ManagementFrame, null, {
      title: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode("span", null, _toDisplayString(_ctx.experimentName), 1)
        ])
      ]),
      controllers: _withId(() => [
        _createVNode(_component_SvgIcon, {
          class: "fs22 pointer",
          icon: "back",
          onClick: _ctx.back
        }, null, 8, ["onClick"])
      ]),
      content: _withId(() => [
        _createVNode("div", null, [
          _createVNode(_component_a_table, {
            class: "mb14 table",
            "row-key": "code",
            pagination: false,
            loading: _ctx.tableLoading,
            "data-source": _ctx.tableList,
            columns: _ctx.columns
          }, {
            experimentScore: _withId(({record}) => [
              _createVNode("div", _hoisted_5, _toDisplayString(record.experimentScore ?? '-'), 1)
            ]),
            ranking: _withId(({record}) => [
              _createVNode("div", _hoisted_6, _toDisplayString(record.ranking ?? '-'), 1)
            ]),
            action: _withId(({record}) => [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", {
                  class: ["text-btn pointer mr8", {'disabled-txt': _ctx.stuStatus(record)}],
                  onClick: ($event: any) => (!_ctx.stuStatus(record) && _ctx.gotoInfo(record))
                }, "查看", 10, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["loading", "data-source", "columns"]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_a_pagination, {
              current: _ctx.pageNo,
              "onUpdate:current": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pageNo = $event)),
              pageSize: _ctx.pageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => (_ctx.pageSize = $event)),
              total: _ctx.total,
              showSizeChanger: "",
              "show-quick-jumper": "",
              onChange: _ctx.pageChange,
              onShowSizeChange: _ctx.showSizeChange
            }, null, 8, ["current", "pageSize", "total", "onChange", "onShowSizeChange"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
})